import { fromJS } from 'immutable';

import * as ActionType from '../actions/retainerHealthReport';

const defaultState = fromJS({
  queryResults: [],
  loading: false,
});

export default function(state = defaultState, action) {
  switch (action.type) {
    case ActionType.FETCHING_RETAINER_HEALTH_REPORT:
      return state.merge({
        loading: true,
      });

    case ActionType.FETCHING_RETAINER_HEALTH_REPORT_SUCCESS:
      return state.mergeDeep({
        loading: false,
        queryResults: action.response.data,
      });

    case ActionType.FETCHING_RETAINER_HEALTH_REPORT_FAILURE:
      return state.merge({
        loading: false,
      });

    default:
      return state;
  }
}
